<template>
	<div>
		<b-form-input
			v-model="proxyValue"
			:value="value"
			type="text"
			class="input-monetary"
			:placeholder="fieldInfo.placeholder"
			:name="fieldInfo.name"
			:id="fieldInfo.id"
			:size="fieldInfo.size"
			:disabled="disabled"
			@blur="emitBlur"
			@keydown="onlyAllowNumbers"
		/>
	</div>
</template>

<script>
export default {
	props: {
		fieldInfo: {
			type: Object
		},
		value: {
			type: String
		},
		disabled: {
			type: Boolean,
			required: false
		}
	},
	computed: {
		proxyValue: {
			get() {
				return this.formatCurrency(this.value);
			},
			set(newValue) {
				this.$emit("input", this.formatCurrency(newValue));
				this.$emit("change", this.fieldInfo.name);
			}
		}
	},
	methods: {
		emitBlur: function () {
			this.$emit("change", this.fieldInfo.name);
			this.$emit("blur", this.fieldInfo);
		},
		formatCurrency(value) {
			if (value === undefined || value === null) return "";

			let cleanedValue = value.toString().replace(/\D/g, "");
			if (cleanedValue === "" || cleanedValue.split("").every((v) => v === "0")) return "";

			const integerPart = cleanedValue.slice(0, -2) || "0";
			const decimalPart = cleanedValue.slice(-2);

			const formattedValue = `${parseInt(integerPart, 10)},${decimalPart}`;
			return formattedValue;
		},
		onlyAllowNumbers(event) {
			const allowedKeys = [
				"Backspace",
				"ArrowLeft",
				"ArrowRight",
				"0",
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"Numpad0",
				"Numpad1",
				"Numpad2",
				"Numpad3",
				"Numpad4",
				"Numpad5",
				"Numpad6",
				"Numpad7",
				"Numpad8",
				"Numpad9"
			];

			if (!allowedKeys.includes(event.key)) {
				event.preventDefault();
			}
		}
	}
};
</script>

<style scoped>
.input-monetary {
	text-align: left;
}
</style>
